/** @jsx jsx */
import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { AnchorButton, Intent, H3, } from '@blueprintjs/core';
import { ColorAliases } from 'styles/variables';
import { GenericObject } from 'interfaces/GenericObject';
import { Sizes } from 'styles/variables-slykit';
import { clampLineCount } from 'styles/styledComponentUtils';
import { HighlightTerms } from './textHighlighter';
import { externalLinkAttributes } from 'components/externalLink';

export interface DocumentHeaderProps {
	/** the SRS data item, could be anything? */
	item: GenericObject<any>, // TODO: type this
	/** the property of item that is the title of the document */
	titleProperty?: string,
	/** the property of item that that contains a primary URL */
	linkProperty?: string,
	/** a that displays the subTitle */
	subTitle?: JSX.Element
}

export interface DocumentHeaderSearchProps extends DocumentHeaderProps {
	/** the terms that have been searched for */
	terms?: string[],
}


/** default component to display the DocumentViewer Header */
export const DefaultDocumentHeader: React.FunctionComponent<DocumentHeaderSearchProps> = ({
	item,
	titleProperty,
	linkProperty,
	terms,
	subTitle,
	children,
	...props
}) => {
	const title = item.propertyValues?.[titleProperty];
	const linkHref = item.propertyValues?.[linkProperty];

	return (
		<HeaderWrapper {...props}>
			<Title title={title}>
				<HighlightTerms terms={terms} noTextMessage={'No Title'} children={title} cy-test="document-header-title" />
			</Title>

			{subTitle}

			<LinkBar>
				{linkProperty && (
					<AnchorButton
						intent={Intent.PRIMARY}
						rightIcon={'arrow-right'}
						text={'Open'}
						href={linkHref}
						disabled={!linkHref}
						{...externalLinkAttributes}
					/>
				)}
				{children}
				{/* {supportBookmarking && <Button icon={'bookmark'} text={'Bookmark'} minimal /> } */}
			</LinkBar>

		</HeaderWrapper>
	)
}
const HeaderWrapper = styled.div`
	padding: ${Sizes.lg} ${Sizes.lg} ${Sizes.md}; 
	border-bottom: 1px solid ${ColorAliases.PT_DIVIDER_BLACK};
`;
const Title = styled(H3)`
	${clampLineCount(4)}
	margin-bottom: ${Sizes.md};
	margin-right: ${Sizes.sm}; // less chance to overlay the close X button
`;

const LinkBar = styled.div`
	display: flex;
	align-items: center;
`
